import { createContext, useContext } from 'react';

export interface GlobalLoaderContextValue {
  showLoader: (key: string, message?: string) => void;
  hideLoader: (key: string) => void;
  isLoading: boolean;
  message: string | undefined;
}

export const GlobalLoaderContext = createContext<GlobalLoaderContextValue | undefined>(undefined);

export const useGlobalLoader = () => {
  const context = useContext(GlobalLoaderContext);
  if (context === undefined) {
    throw new Error('useGlobalLoader must be used within a GlobalLoaderProvider');
  }
  return context;
};
